import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { auth, db } from '../firebase';
import { collection, query, orderBy, onSnapshot } from 'firebase/firestore';

// লোকাল কন্টাক্ট চেক করার ফাংশন
function getLocalContacts() {
  try { return JSON.parse(localStorage.getItem('nexora_local_contacts') || '{}'); } catch (e) { return {}; }
}
const normalizePhone = (p) => {
  if (!p) return '';
  let d = p.replace(/\D/g, '');
  if (d.startsWith('880')) d = d.substring(3);
  if (d.startsWith('0')) d = d.substring(1);
  return `+880${d}`;
};

const CallLog = () => {
  const navigate = useNavigate();
  const [callLogs, setCallLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  

  useEffect(() => {
    const userUid = localStorage.getItem('nexora_user_uid') || auth.currentUser?.uid;
    if (!userUid) { navigate('/login'); return; }

    // ইউজারের callHistory কালেকশন থেকে ডেটা ফেচ করা
    const logsRef = collection(db, 'users', userUid, 'callHistory');
    const q = query(logsRef, orderBy('createdAt', 'desc'));

    const unsubscribe = onSnapshot(q, (snapshot) => {
      const logs = [];
      snapshot.forEach((docSnap) => {
        logs.push({ id: docSnap.id, ...docSnap.data() });
      });
      setCallLogs(logs);
      setLoading(false);
    });

    return () => unsubscribe();
  }, [navigate]);

  const handleBack = () => {
    navigate(-1);
  };

  const handleCallBack = (targetUid, callType) => {
    navigate('/call', { state: { targetUid, callType } });
  };

  // টাইমস্ট্যাম্প ফরমেট করা
  const formatTime = (createdAt) => {
    if (!createdAt) return '';
    const dateObj = createdAt.seconds ? new Date(createdAt.seconds * 1000) : new Date(createdAt);
    const now = new Date();
    const timeStr = dateObj.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    
    if (now.toDateString() === dateObj.toDateString()) return `Today, ${timeStr}`;
    
    const yesterday = new Date(now);
    yesterday.setDate(now.getDate() - 1);
    if (yesterday.toDateString() === dateObj.toDateString()) return `Yesterday, ${timeStr}`;
    
    return `${dateObj.toLocaleDateString([], { month: 'short', day: 'numeric' })}, ${timeStr}`;
  };

  const localContacts = getLocalContacts();

  return (
    <div style={styles.container}>
      <style>{`
        * { box-sizing: border-box; font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif; -webkit-tap-highlight-color: transparent; }
        body, html, #root { margin: 0; padding: 0; height: 100%; width: 100%; overflow: hidden; background: #fafafa; }
        
        .log-card { 
          width: 100%; max-width: 480px; height: 100%; background: #fafafa; display: flex; flex-direction: column; position: relative; 
          animation: slideInRight 0.25s cubic-bezier(0.25, 1, 0.5, 1) forwards; 
        }
        @keyframes slideInRight { from { transform: translateX(100%); opacity: 0; } to { transform: translateX(0); opacity: 1; } }
        @keyframes slideOutRight { from { transform: translateX(0); opacity: 1; } to { transform: translateX(100%); opacity: 0; } }
        
        @media (min-width: 768px) { .log-card { height: 92vh; border-radius: 36px; border: 1px solid #f1f5f9; box-shadow: 0 0 40px rgba(0,0,0,0.04); } }

        .header-bar { background: #ffffff; padding: 12px 16px; padding-top: max(16px, env(safe-area-inset-top)); display: flex; align-items: center; gap: 16px; border-bottom: 1px solid #f1f5f9; z-index: 30; flex: 0 0 auto; }
        .back-btn { background: none; border: none; cursor: pointer; padding: 0; display: flex; align-items: center; justify-content: center; }
        
        .logs-content { flex: 1; overflow-y: auto; padding: 12px; display: flex; flex-direction: column; gap: 8px; }
        
        .log-item { display: flex; align-items: center; justify-content: space-between; padding: 12px 16px; background: #ffffff; border-radius: 20px; border: 1px solid #f1f5f9; cursor: pointer; transition: 0.2s; }
        .log-item:active { transform: scale(0.98); background: #f8fafc; }

        .avatar { width: 48px; height: 48px; border-radius: 50%; object-fit: cover; border: 1px solid #e2e8f0; }
        .log-info { flex: 1; margin-left: 14px; display: flex; flex-direction: column; justify-content: center; }
        .log-name { font-size: 16px; font-weight: 800; color: #0f172a; margin: 0 0 4px 0; }
        
        .log-details { font-size: 12px; color: #64748b; font-weight: 600; display: flex; align-items: center; gap: 6px; }
        .call-icon { display: flex; align-items: center; justify-content: center; width: 16px; height: 16px; border-radius: 50%; }
        
        .incoming { color: #16a34a; }
        .outgoing { color: #2563eb; }
        .missed { color: #ef4444; }

        .action-btn { width: 40px; height: 40px; border-radius: 50%; background: #f0fdf4; border: none; display: flex; align-items: center; justify-content: center; cursor: pointer; }
        .action-btn.video { background: #eff6ff; }
      `}</style>

      <div className="log-card">
        
        <div className="header-bar">
          <button onClick={handleBack} className="back-btn">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#0f172a" strokeWidth="2.5"><path d="M19 12H5M12 19l-7-7 7-7"/></svg>
          </button>
          <span style={{ fontSize: '18px', fontWeight: '800', color: '#0f172a' }}>Call History</span>
        </div>

        <div className="logs-content">
          {loading ? (
            <div style={{ textAlign: 'center', marginTop: '40px', color: '#94a3b8', fontWeight: '600' }}>Loading calls...</div>
          ) : callLogs.length === 0 ? (
            <div style={{ textAlign: 'center', marginTop: '60px', color: '#94a3b8', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="#cbd5e1" strokeWidth="1.5"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.79 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/></svg>
              <h3 style={{ margin: '16px 0 8px', color: '#0f172a', fontWeight: '800' }}>No Calls Yet</h3>
              <p style={{ margin: 0, fontSize: '13px' }}>Your recent calls will appear here.</p>
            </div>
          ) : (
            callLogs.map((log) => {
              // নাম সিঙ্ক করা
              const phoneKey = normalizePhone(log.targetPhone);
              let displayName = log.targetName || log.targetPhone || 'Unknown';
              if (localContacts[phoneKey]) displayName = localContacts[phoneKey];

              const isMissed = log.status === 'missed';
              const isIncoming = log.direction === 'incoming';

              return (
                <div key={log.id} className="log-item" onClick={() => navigate(`/profile-info/${log.targetId}`)}>
                  
                  <img src={log.targetPhoto || "https://images.unsplash.com/photo-1535713875002-d1d0cf377fde?w=150"} alt="User" className="avatar" />
                  
                  <div className="log-info">
                    <h3 className="log-name" style={{ color: isMissed ? '#ef4444' : '#0f172a' }}>{displayName}</h3>
                    <div className="log-details">
                      
                      {/* Call Direction Indicator */}
                      <span className={`call-icon ${isMissed ? 'missed' : isIncoming ? 'incoming' : 'outgoing'}`}>
                        {isIncoming && !isMissed && <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3"><polyline points="20 21 9 21 9 10"/><line x1="20" y1="4" x2="9" y2="21"/></svg>}
                        {!isIncoming && !isMissed && <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3"><polyline points="15 3 21 3 21 9"/><line x1="10" y1="14" x2="21" y2="3"/></svg>}
                        {isMissed && <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.79 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>}
                      </span>
                      
                      <span>{formatTime(log.createdAt)}</span>
                      {log.duration && <span style={{opacity: 0.6}}>• {log.duration}</span>}
                    </div>
                  </div>

                  <button 
                    onClick={(e) => { e.stopPropagation(); handleCallBack(log.targetId, log.type || 'audio'); }} 
                    className={`action-btn ${log.type === 'video' ? 'video' : ''}`}
                  >
                    {log.type === 'video' ? (
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#2563eb" strokeWidth="2"><polygon points="23 7 16 12 23 17 23 7"/><rect x="1" y="5" width="15" height="14" rx="3"/></svg>
                    ) : (
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#16a34a" strokeWidth="2"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.79 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/></svg>
                    )}
                  </button>

                </div>
              );
            })
          )}
        </div>
      </div>
    </div>
  );
};

// Styles Add করা হলো
const styles = {
  container: { position: 'fixed', top: 0, left: 0, right: 0, bottom: '64px', backgroundColor: '#fafafa', display: 'flex', justifyContent: 'center', alignItems: 'center' }
};

export default CallLog;